import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Award, Shield, Clock, CheckCircle, 
  Phone, Mail, MapPin, Send, ArrowRight, Home, BookOpen,
  Brain, Target, Zap, Star, TrendingUp, Globe, Lock,
  FileText, Scale,  Building, Gavel, Heart, Lightbulb,
  Baby, UserCheck, Users as FamilyMembers,
  Building2, Home as House, FileCheck, Briefcase,
  Building as Corporate, FileText as Document, Users as Team,
  Globe as World, CheckSquare, ArrowUpRight,
  Home as RealEstateIcon, Building as Property, MapPin as Location,
  FileText as Contract, Shield as Legal, CheckCircle as Success,
  FileText as Patent, Shield as Trademark, Globe as Industrial,
  Award as Copyright, CheckCircle as SecurityProtection, FileText as Registration,
  Users as Arbitrators, Scale as Mediation, Users as Settlement,
  FileText as Arbitration, Shield as Conciliation, CheckCircle as Resolution,
  Lock as Privacy, FileText as Terms, Shield as DataProtection,
  Globe as Digital, CheckCircle as Compliance, FileText as Policy,
  FileText as Notarization, Building as RealEstate, FileText as Agency,
  Shield as Mortgage, FileText as Company, FileText as Minutes,
  FileText as IntellectualProperty, FileText as MovableProperty,
  FileText as Guarantee
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotarizationServices = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [visibleSections, setVisibleSections] = useState({
    hero: false,
    about: false,
    types: false,
    process: false,
    features: false,
    'why-choose-us': false,
    contact: false
  });

  useEffect(() => {
    setIsVisible(true);
    
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute('data-section');
          if (sectionId) {
            setVisibleSections(prev => ({
              ...prev,
              [sectionId]: true
            }));
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all sections
    const sections = document.querySelectorAll('[data-section]');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  const notarizationServices = [
    {
      icon: RealEstate,
      title: "إفراغ صكوك الملكية العقارية",
      description: "توثيق نقل ملكية العقارات بكل دقة ومهنية، مع ضمان التزام الإجراءات بكافة الأنظمة واللوائح",
      image: "/images/services/91.png"
    },
    {
      icon: Agency,
      title: "الوكالات وفسخها",
      description: "توثيق الوكالات القانونية المتنوعة، مع تيسير توثيق فسخها أو تعديل بنودها",
      image: "/images/services/112.png"
    },
    {
      icon: Mortgage,
      title: "الرهن وفكه وتعديله",
      description: "خدمات توثيق الرهن العقاري، بما في ذلك تعديل أو فك الرهن حسب الحاجة",
      image: "/images/services/113.png"
    },
    {
      icon: Company,
      title: "عقود تأسيس الشركات وملاحق التعديل",
      description: "توثيق عقود تأسيس الشركات وملاحق التعديلات الخاصة بها، بما يتوافق مع الأنظمة المحلية",
      image: "/images/services/114.png"
    },
    {
      icon: Minutes,
      title: "محاضر الشركات",
      description: "توثيق المحاضر الخاصة باجتماعات الشركات العامة والخاصة، لنضمن صحة المحاضر قانونيًا",
      image: "/images/services/121.png"
    },
    {
      icon: IntellectualProperty,
      title: "التصرفات والعقود المتعلقة بالملكية الفكرية",
      description: "توثيق المعاملات القانونية المتعلقة بالعلامات التجارية وبراءات الاختراع وحقوق المؤلف",
      image: "/images/services/122.png"
    },
    {
      icon: MovableProperty,
      title: "العقود المتعلقة بالمال المنقول",
      description: "توثيق العقود الخاصة بالمال المنقول، لنضمن حفظ الحقوق القانونية للأطراف المعنية",
      image: "/images/services/123.png"
    },
    {
      icon: Guarantee,
      title: "إقرار الكفالة الغرمية",
      description: "توثيق إقرارات الكفالة الغرمية، وفقًا للأنظمة المعمول بها في المملكة",
      image: "/images/services/124.png"
    }
  ];

  const notarizationFeatures = [
    "فريق من المحامين والمستشارين القانونيين المتخصصين في التوثيق",
    "خدمات توثيق شاملة تضمن صحة وموثوقية جميع الوثائق القانونية",
    "ضمان الامتثال الكامل للقوانين والأنظمة السعودية",
    "تعزيز قوة أُسس المعاملات التجارية والقانونية",
    "حماية الحقوق القانونية للأفراد والشركات",
    "تعزيز استقرار البيئة القانونية في كافة المجالات"
  ];

  const notarizationProcess = [
    {
      step: "01",
      title: "دراسة الوثيقة",
      description: "دراسة دقيقة للوثيقة والمتطلبات القانونية",
      icon: FileText
    },
    {
      step: "02",
      title: "إعداد الملف",
      description: "إعداد ملف التوثيق والمستندات المطلوبة",
      icon: Document
    },
    {
      step: "03",
      title: "التوثيق القانوني",
      description: "توثيق الوثيقة وفق الأنظمة واللوائح المعمول بها",
      icon: Notarization
    },
    {
      step: "04",
      title: "متابعة الإجراءات",
      description: "متابعة إجراءات التوثيق وحماية الحقوق",
      icon: Shield
    }
  ];



  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div 
        data-section="hero"
        className={`relative bg-gradient-to-br from-[#0a3a23] via-[#0a3a23] to-[#0a3a23] py-12 sm:py-24 overflow-hidden transition-all duration-1000 mt-20 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className={`relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center text-white transition-all duration-1000 delay-300 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="mb-4 sm:mb-8">
            <span className="text-white text-lg sm:text-xl animate-pulse">خدمات قانونية متخصصة</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
            <span className="text-white">خدمات التوثيق</span>
            <div className="w-20 sm:w-32 h-1 bg-white mx-auto mt-2 sm:mt-4 animate-pulse"></div>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl opacity-90 max-w-2xl sm:max-w-4xl mx-auto leading-relaxed mb-4 sm:mb-8 px-4">
            نقدم خدمات توثيق شاملة تضمن صحة وموثوقية جميع الوثائق القانونية
          </p>
          <p className="text-sm sm:text-base md:text-lg opacity-80 max-w-xl sm:max-w-3xl mx-auto px-4">
            نحرص على تقديم خدمات قانونية متكاملة، مدروسة، ومبنية على أسس شرعية ونظامية راسخة
          </p>
        </div>

        {/* Navigation Breadcrumb */}
        <div className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-1 sm:gap-2 text-white text-xs sm:text-sm">
          <Link to="/" className="flex items-center gap-1 hover:text-white/70 transition-colors">
            <Home className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>الرئيسية</span>
          </Link>
          <span>/</span>
          <div className="flex items-center gap-1">
            <BookOpen className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>خدمات التوثيق</span>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div data-section="about" className="py-12 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div className={`transition-all duration-1000 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 sm:mb-8">
                نبذة عن التوثيق
              </h2>
              <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
                <p>
                  التوثيق هو سلسلة من الإجراءات القانونية الهادفة إلى ضمان صحة وموثوقية المحررات والوثائق القانونية، لتكون قابلة للاحتجاج بها أمام الجهات الرسمية والهيئات القضائية.
                </p>
                <p>
                  يُعدُّ التوثيق من الأسس الجوهرية في الأنظمة القانونية، حيث يُسهم في تعزيز الأمان القانوني ويسهم في استقرار المعاملات التجارية والشخصية.
                </p>
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-xl border-r-4 border-[#0a3a23]">
                  <p className="text-[#0a3a23] font-bold mb-3 sm:mb-4 text-sm sm:text-base">أهمية التوثيق:</p>
                  <div className="space-y-2 sm:space-y-3 text-[#0a3a23]">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23] flex-shrink-0" />
                      <span className="text-sm sm:text-base"><strong>ضمان صحة الوثائق</strong></span>
                    </div>
                    <div className="flex items-center gap-2 sm:gap-3">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23] flex-shrink-0" />
                      <span className="text-sm sm:text-base"><strong>حماية التعاملات بين الأفراد</strong></span>
                    </div>
                    <div className="flex items-center gap-2 sm:gap-3">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23] flex-shrink-0" />
                      <span className="text-sm sm:text-base"><strong>زيادة الثقة في التعاملات التجارية</strong></span>
                    </div>
                  </div>
                </div>
                <p className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-xl border-r-4 border-[#0a3a23]">
                  <strong className="text-[#0a3a23] text-sm sm:text-base">فريقنا من القانونيين على دراية وكفاءة عالية في مجال التوثيق، مع ضمان الحماية القانونية الكاملة لحقوقك.</strong>
                </p>
              </div>
            </div>
            
            <div className={`relative transition-all duration-1000 delay-300 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <img 
                src="/images/services/121.png"
                alt="خدمات التوثيق"
                className="rounded-xl sm:rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Notarization Services */}
      <div data-section="types" className="py-12 sm:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.types ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              خدمات التوثيق المتخصصة
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
              نقدم خدمات توثيق شاملة تضمن صحة وموثوقية جميع الوثائق القانونية
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {notarizationServices.map((service, index) => (
              <div 
                key={index} 
                className={`bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden group transform hover:scale-105 ${visibleSections.types ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 right-3 sm:right-4">
                    <service.icon className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                  </div>
                </div>
                
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0a3a23] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Notarization Process */}
      <div data-section="process" className="py-12 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.process ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              خطوات خدمات التوثيق
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
              عملية منظمة ومهنية لخدمات التوثيق القانوني
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {notarizationProcess.map((step, index) => (
              <div 
                key={index} 
                className={`text-center group transition-all duration-500 ${visibleSections.process ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 300}ms` }}
              >
                <div className="relative mb-4 sm:mb-6">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    <step.icon className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 sm:w-8 sm:h-8 bg-[#0a3a23] rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm">
                    {step.step}
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{step.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Features */}
      <div data-section="features" className="py-12 sm:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              مميزات خدمات التوثيق
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
              نتميز بخبرة واسعة وخدمة متميزة في مجال التوثيق القانوني
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {notarizationFeatures.map((feature, index) => (
              <div 
                key={index} 
                className={`flex items-start gap-3 sm:gap-4 p-4 sm:p-6 rounded-xl bg-[#0a3a23]/10 hover:bg-[#0a3a23]/20 transition-all duration-500 transform hover:scale-105 ${visibleSections.features ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-[#0a3a23] mt-1 flex-shrink-0" />
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* Why Choose Us Section */}
      <section data-section="why-choose-us" id="section-why-choose-us" className={`py-16 mb-16 relative overflow-hidden transition-all duration-1000 delay-900 ${visibleSections['why-choose-us'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{ backgroundColor: '#0A3A23' }}>
        {/* Subtle Pattern Overlay */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-32 h-32 border border-white/10 rounded-full"></div>
          <div className="absolute bottom-20 right-20 w-48 h-48 border border-white/10 rounded-full"></div>
          <div className="absolute top-1/3 right-1/4 w-20 h-20 border border-white/10 rounded-full"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10">
          {/* Why Choose Us Title */}
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-white mb-6">لماذا تختارنا ؟</h2>
          </div>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a
              href="https://wa.me/966115115945?text=أريد خدمات التوثيق"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] hover:from-[#0a3a23] hover:to-[#0a3a23] text-white px-6 py-3 rounded-xl font-semibold text-base transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              احصل على استشارة
            </a>
            <a
              href="/images/about/أنس الخياط - ملف تعريفي-5 (1).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] hover:from-[#0a3a23] hover:to-[#0a3a23] text-white px-6 py-3 rounded-xl font-semibold text-base transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              الملف التعريفي
            </a>
          </div>

          {/* Divider */}
          <div className="w-full border-t-2 border-dashed border-yellow-400 mb-8"></div>
          
          {/* Scales of Justice Icon */}
          <div className="flex justify-center mb-8">
            <Scale className="w-12 h-12 text-yellow-400" />
          </div>

          {/* Why Choose Us Grid */}
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400">
                <Shield className="w-8 h-8 text-yellow-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">نفكر كعميل</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                نعمل معا خطوة بخطوة، حتى نستنفذ كل السبل القانونية لحل مشكلتك، مهما كانت معقدة للحصول على افضل الحلول الممكنة.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400">
                <Users className="w-8 h-8 text-yellow-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">نعمل كشريك</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                نؤمن بأنك شريك حقيقي لنا، ونعمل جنبا إلى جنب لتحقيق أهدافك، لأن نجاحك هو نجاحنا.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-yellow-400">
                <Lightbulb className="w-8 h-8 text-yellow-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">نحفظ خصوصيتك</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                خصوصيتك أولوية، ومعلوماتك في أيد أمينة ونلتزم بحمايتها بكل احترافية وضمن إطار العلاقة القانونية التي تجمعنا.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=أريد خدمات التوثيق`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NotarizationServices;
